import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { HTTPError } from 'ky';
import { api } from "../client/backend";

export const NewsletterDialog = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const { toast } = useToast();

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      console.log("Attempting to subscribe:", { name, email });

      await api.post('subscribers', {
        json: { name, email }
      });

      console.log("Subscription successful");

      // Clear form
      setName("");
      setEmail("");

      // Close dialog
      setIsDialogOpen(false);

      toast({
        title: "You're subscribed to SLAY - stay tuned for updates!🌈✨",
        duration: 2000,
      });

    } catch (error) {
      console.error("Subscription error:", error);
      let description = "Please try again later";
      if (error instanceof HTTPError) {
        description = `Subscription failed: ${error.response.status}`;
      }
      toast({
        title: "Subscription failed",
        description: description,
        variant: "destructive",
      });
    }
  };

  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogTrigger asChild>
        <Button
          variant="outline"
          className="relative text-[#6E59A5] hover:bg-[#E0C3FC] hover:text-white px-8 py-6 rounded-full text-lg font-medium transition-all duration-300 ease-out hover:scale-105 border-2 border-transparent before:absolute before:inset-0 before:rounded-full before:border-2 before:border-transparent before:bg-gradient-to-r before:from-[#FF0018] before:via-[#FFA52C] before:to-[#00B5E2] before:animate-border-rainbow before:-z-10"
        >
          Subscribe to Newsletter
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md bg-[#221F26] text-white border-[#403E43]">
        <DialogHeader>
          <DialogTitle className="text-center text-xl font-semibold text-white">
            💌 Stay in the Loop!
          </DialogTitle>
          <p className="text-center text-gray-300 mt-2">
            Get exclusive LGBTQIA+ event updates, special offers, and community news—straight to your inbox! 🌈✨
          </p>
        </DialogHeader>
        <form onSubmit={handleSubscribe} className="space-y-4 mt-4">
          <div className="space-y-2">
            <Label htmlFor="name" className="text-white">Name</Label>
            <Input
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter your name"
              required
              className="bg-[#403E43] border-[#6E59A5] text-white placeholder:text-gray-400"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="email" className="text-white">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              className="bg-[#403E43] border-[#6E59A5] text-white placeholder:text-gray-400"
            />
          </div>
          <Button
            type="submit"
            className="w-full bg-[#6E59A5] hover:bg-[#7E69AB] text-white transition-colors"
          >
            Submit
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
